<template>
  <v-card color="grey lighten-3" style="height: 100vh; width:100%;">
      <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('fechar')">
              <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Estatísticas</v-toolbar-title>

      </v-toolbar>

      <v-layout align-center class="ma-3">
          <v-row>
              <!-- <v-col sm="12" xs="12" md="12" lg="6">
                  <v-card height="400">
                      <div class="v-chart-offset" align="center">
                          <apexchart width="550" type="bar" :options="optionsPacientesPorHora" :series="seriesPacientesPorHora"></apexchart>
                      </div>
                  </v-card>
              </v-col> -->
              <v-col sm="12" xs="12" md="12" lg="7">
                  <v-card height="400" class="mt-3">
                      <v-row>
                        <v-col>
                          <v-card justify-content-center outlined class="mx-3 text-center">
                            <v-card-title class="justify-center"> Hoje</v-card-title>
                            <v-card-subtitle>Total de atendimentos</v-card-subtitle>
                            <v-card-text class="font-size-30">
                              <div v-if="!loadMetricasDiarias">
                                <p class="text-h4 text--primary">
                                  {{totalAtendimentosDiario}}
                                </p>
                                <div class="container justify-center mb-0">
                                  <div class="ball mr-1"></div>
                                  <div class="ball mr-1"></div>
                                  <div class="ball"></div>
                              </div>
                              </div>

                              <v-skeleton-loader v-if="loadMetricasDiarias"
                                v-bind="attrs"
                                type="list-item-two-line"
                              ></v-skeleton-loader>
                            </v-card-text>
                            <v-divider/>
                            <v-card-subtitle>Média de tempo por atendimento</v-card-subtitle>
                            <v-card-text>
                              <div v-if="!loadMetricasDiarias">
                                <p class="text-h4 text--primary mb-0">
                                  {{mediaTempoAtendimentoDiario}}
                                </p>
                                minutos
                              </div>
                              <v-skeleton-loader v-if="loadMetricasDiarias"
                                v-bind="attrs"
                                type="list-item-two-line"
                              ></v-skeleton-loader>
                            </v-card-text>

                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card outlined class="mx-3 text-center">
                            <v-card-title class="justify-center">Abril</v-card-title>
                            <v-card-subtitle>Total de atendimentos</v-card-subtitle>
                            <v-card-text class="font-size-30">
                              <div v-if="!loadMetricasDiarias">
                                <p class="text-h4 text--primary">
                                  {{totalAtendimentosMensal}}
                                </p>
                              </div>
                              <v-skeleton-loader v-if="loadMetricasDiarias"
                                v-bind="attrs"
                                type="list-item-two-line"
                              ></v-skeleton-loader>
                            </v-card-text>
                            <v-divider/>
                            <v-card-subtitle>Média de tempo por atendimento</v-card-subtitle>
                            <v-card-text>
                              <div v-if="!loadMetricasDiarias">
                                <p class="text-h4 text--primary mb-0">
                                  {{mediaTempoAtendimentoMensal}}
                                </p>
                                minutos
                              </div>
                              <v-skeleton-loader v-if="loadMetricasDiarias"
                                v-bind="attrs"
                                type="list-item-two-line"
                              ></v-skeleton-loader>

                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card outlined class="mx-3 text-center">
                            <v-card-title class="justify-center">2023</v-card-title>
                            <v-card-subtitle>Total de atendimentos</v-card-subtitle>
                            <v-card-text class="font-size-30">
                              <div v-if="!loadMetricasDiarias">
                                <p class="text-h4 text--primary">
                                  {{totalAtendimentosAnual}}
                                </p>
                              </div>
                              <v-skeleton-loader v-if="loadMetricasDiarias"
                                v-bind="attrs"
                                type="list-item-two-line"
                              ></v-skeleton-loader>
                            </v-card-text>
                            <v-divider/>
                            <v-card-subtitle>Média de tempo por atendimento</v-card-subtitle>
                            <v-card-text>
                              <div v-if="!loadMetricasDiarias">
                                <p class=" text-h4 text--primary mb-0">
                                  {{mediaTempoAtendimentoAnual}}
                                </p>
                                minutos
                              </div>
                              <v-skeleton-loader v-if="loadMetricasDiarias"
                                v-bind="attrs"
                                type="list-item-two-line"
                              ></v-skeleton-loader>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                  </v-card>
              </v-col>
                  <v-card>
                      <v-card-title>
                          Pacientes atendidos
                      </v-card-title>
                  </v-card>
              </v-col>

              <v-col cols="3">
                  <v-card>
                      <v-card-title>
                          Receitas
                      </v-card-title>
                  </v-card>
              </v-col>
              <v-col cols="3">
                  <v-card>
                      <v-card-title>
                          Pacientes atendidos
                      </v-card-title>
                  </v-card>
              </v-col>
              <v-col cols="3">
                  <v-card>
                      <v-card-title>
                          Pacientes atendidos
                      </v-card-title>
                  </v-card>
              </v-col> -->
          </v-row>
      </v-layout>
  </v-card>
</template>

<script>
// import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import medicoService from '../../services/medico.service'
export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    user: '',
    load: false,
    dialog: false,
    mediaTempoAtendimentoDiario: '',
    totalAtendimentosDiario: '',
    mediaTempoAtendimentoMensal: '',
    totalAtendimentosMensal: '',
    mediaTempoAtendimentoAnual: '',
    totalAtendimentosAnual: '',

    optionsSenhaEmAberto: {
      chart: {
        id: 'senhas-aberto'
      },
      title: {
        text: 'Status das senhas em aberto',
        align: 'left',
        style: {
          fontSize: '16px'
        }
      },
      labels: ['Disponíveis', 'Em espera', 'Pendentes', 'Atendidos'],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                showAlways: true,
                show: true,
                fontSize: 20
              },
              value: {
                show: true,
                fontSize: '22px'
              }
            }

          }

        }
      }

    },
    seriesSenhaEmAberto: [10, 20, 30, 25],
    labelsSenhaEmAberto: ['Disponíveis', 'Em espera', 'Pendentes', 'Atendidos'],
    mediaHorarios: null,
    chart: '',
    loadMetricasDiarias: false

  }),
  methods: {
    retornarMetricasMensalAnual () {
      this.load = true
      medicoService.medico.retornarMetricasDeAtendimentoMensaisAnuais(this.user.id).then(r => {
        if (r.status == 200) {
          this.mediaTempoAtendimentoMensal = r.data.metricas.mensal[2].mediaMinutos.toFixed(1)
          this.totalAtendimentosMensal = r.data.metricas.mensal[2].quantidade
          this.mediaTempoAtendimentoAnual = r.data.metricas.anual[0].media.toFixed(1)
          this.totalAtendimentosAnual = r.data.metricas.anual[0].quantidade
          console.log('DEU BOM: ', r.data)
        } else {
          console.log('DEU RUIM: ', r.status)
        }
      }).finally(() => {
        this.load = false
      })
    },
    retornarMetricasDiarias () {
      this.loadMetricasDiarias = true
      const dataAtual = new Date()
      const dataFormatada = `${dataAtual.getFullYear()}-${('0' + (dataAtual.getMonth() + 1)).slice(-2)}-${('0' + dataAtual.getDate()).slice(-2)}`
      console.log(dataFormatada)

      medicoService.medico.retornarMetricasDeAtendimento(this.user.id, dataFormatada, dataFormatada).then(r => {
        if (r.status == 200) {
          if (r.data.mediaMinutos != null) {
            this.mediaTempoAtendimentoDiario = r.data.mediaMinutos.toFixed(1)
          } else {
            this.mediaTempoAtendimentoDiario = 0
          }
          this.totalAtendimentosDiario = r.data.quantidade
        } else {
          console.log('NAO veio ----> ')
        }
      }).finally(() => {
        this.loadMetricasDiarias = false
      })
    },
    buscarQuantidadeDeAtendimentosPorStatus () {
      medicoService.medico.buscarQuantidadeDeAtendimentosPorStatus(this.user.id).then(r => {
        if (r.status == 200) {

        }
      }).finally(() => {

      })
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.retornarMetricasMensalAnual()
    this.retornarMetricasDiarias()
    // this.buscarQuantidadeDeAtendimentosPorStatus()
  }
}
</script>

<style scoped>
.chart-horario-atendimento {
    top:45px;
    position: relative;
}
.v-chart-offset {
    padding-top: 15px;
}
.container{
  display:flex;
  flex-wrap: wrap;
  align-items: flex-end;

}
.ball{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: red;
  animation: bounce .5s alternate infinite;
}
.ball:nth-child(2){
  animation-delay: .16s;
}
.ball:nth-child(3){
  animation-delay: .32s;
}

@keyframes bounce{
  fron{
    transform: scaleX(1.05);
  }
  to{
    transform: translateY(-12px) scaleX(1.1)
  }
}
</style>
